import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";
import { ColorArray } from "../../config/ColorArray";
import { getUpperPrimarySubjectsByStandard } from "../../utils/subjectService";
import "../PrathmikVibhag/Subjects.css";
import SectionDivider from "../../common/SectionDivider";

const UpperPrimarySubjects = () => {
    const navigate = useNavigate();
    const [subjects, setSubjects] = useState([]);
    const [standardIndex, setStandardIndex] = useState(6);
    const [selectedSem, setSelectedSem] = useState(1);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const sub = localStorage.getItem("upperPrimarySubjectsData");
        const std = localStorage.getItem("upperPrimarySelectedStandard");
        const sem = localStorage.getItem("upperPrimarySelectedSem");

        if (sub) setSubjects(JSON.parse(sub));
        if (std) {
            const parsedStd = JSON.parse(std);
            if (parsedStd?.standard_index != null) {
                setStandardIndex(Number(parsedStd.standard_index));
            }
        }
        if (sem) {
            const n = Number(sem);
            if (n === 1 || n === 2) setSelectedSem(n);
        }
    }, []);

    useEffect(() => {
        let ignore = false;

        const fetchSubjects = async () => {
            setLoading(true);
            try {
                const data = await getUpperPrimarySubjectsByStandard(standardIndex, selectedSem);
                if (ignore) return;
                setSubjects(data);
                localStorage.setItem("upperPrimarySubjectsData", JSON.stringify(data));
                localStorage.setItem("upperPrimarySelectedSem", String(selectedSem));
            } finally {
                if (!ignore) setLoading(false);
            }
        };

        if (standardIndex != null) fetchSubjects();
        return () => {
            ignore = true;
        };
    }, [standardIndex, selectedSem]);

    const uiColor = ColorArray?.[0]?.color2 || "#3b82f6";

    return (
        <>
            <div className="std">
                <SectionDivider
                    title={`ઉચ્ચતર પ્રાથમિક વિભાગ ના ધોરણ ${standardIndex} (સત્ર ${selectedSem})ના વિષયો`}
                />
            </div>
            <div className="subjects-screen">
                <div className="session-toggle">
                    <button
                        className={`session-button ${selectedSem === 1 ? "active" : ""}`}
                        style={selectedSem === 1 ? { background: uiColor } : undefined}
                        onClick={() => setSelectedSem(1)}
                    >
                        સત્ર 1
                    </button>
                    <button
                        className={`session-button ${selectedSem === 2 ? "active" : ""}`}
                        style={selectedSem === 2 ? { background: uiColor } : undefined}
                        onClick={() => setSelectedSem(2)}
                    >
                        સત્ર 2
                    </button>
                </div>



                <div className="subjects-list">
                    {loading ? (
                        <Loader />
                    ) : subjects.length === 0 ? (
                        <div style={{ textAlign: "center", color: "#6b7280", padding: "20px" }}>
                            No subjects found
                        </div>
                    ) : (
                        subjects.map((s, index) => {
                            const colorData = ColorArray[index % ColorArray.length];
                            const color1 = colorData ? colorData.color1 : "#968bf7";
                            const color2 = colorData ? colorData.color2 : "#1c00ff";

                            return (
                                <div
                                    key={s.id}
                                    className="subject-card"
                                    style={{
                                        background: `linear-gradient(to bottom, ${color1}, ${color2})`,
                                    }}
                                >
                                    {s.subject_image && (
                                        <img
                                            src={s.subject_image}
                                            alt={s.subject_title}
                                            className="subject-image"
                                        />
                                    )}

                                    <p className="subject-name">{s.subject_title}</p>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </>
    );
};

export default UpperPrimarySubjects;
